export default __webpack_public_path__ + "static/media/news1.ee214eeb.svg";